import React, { useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO = "/logo.png";

const NAV = [
  { label: "WORK", href: "#work" },
  { label: "SERVICES", href: "#services" },
  { label: "CONTACT", href: "#contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/85 backdrop-blur-md border-b border-[#1f1f1f]"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-6 md:px-10 pt-5 md:pt-7 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" className="block">
          <img
            src={LOGO}
            alt="Tyrelle Sound"
            data-testid="logo-image"
            className="h-24 sm:h-28 md:h-32 w-auto"
            style={{ filter: "brightness(0) invert(1)" }}
          />
        </a>

        <nav className="hidden md:flex items-center gap-10 pt-4">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.href.replace("#", "")}`}
              className="font-mono-indie font-semibold text-[13px] tracking-[0.18em] text-[#f4f1ea] hover:text-[#e8472b] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden brutal-border bg-[#fdfd96] p-2 mt-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-[#f4f1ea] border-y-2 border-foreground px-6 py-4 flex flex-col gap-3 mt-4">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-mobile-${n.href.replace("#", "")}`}
              className="font-mono-indie font-semibold text-sm tracking-widest"
              onClick={() => setOpen(false)}
            >
              {n.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;
